import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || "Authentication failed.");
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data }, replace: true });
      })
      .catch((err) => {
        setError(err.message);
        toast.error(err.message);
        setTimeout(() => navigate("/admin/login", { replace: true }), 1800);
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center" data-testid="auth-callback-screen">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto rounded-full border-2 border-gold border-t-transparent animate-spin" />
        <p className="mt-5 text-sm text-slate-300">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
